module.exports = __webpack_public_path__ + "static/img/title.dcb6103.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reserve/title.png
// module id = YdYW
// module chunks = 1